export var ChargeStatus;
(function (ChargeStatus) {
    ChargeStatus[ChargeStatus["PENDING"] = 1] = "PENDING";
    ChargeStatus[ChargeStatus["PAID"] = 2] = "PAID";
    ChargeStatus[ChargeStatus["OVERDUE"] = 3] = "OVERDUE";
    ChargeStatus[ChargeStatus["EXPIRED"] = 4] = "EXPIRED";
    ChargeStatus[ChargeStatus["CREATING"] = 5] = "CREATING";
    ChargeStatus[ChargeStatus["ERROR"] = 6] = "ERROR";
    ChargeStatus[ChargeStatus["PENDING_PAYER_CREATE"] = 7] = "PENDING_PAYER_CREATE";
    ChargeStatus[ChargeStatus["PENDING_PAYMENT"] = 8] = "PENDING_PAYMENT";
    ChargeStatus[ChargeStatus["CANCELLED"] = 9] = "CANCELLED";
})(ChargeStatus || (ChargeStatus = {}));
export var StatusType;
(function (StatusType) {
    StatusType["ISSUING"] = "issuing";
    StatusType["PENDING"] = "pending";
    StatusType["PAID"] = "paid";
    StatusType["OVERDUE"] = "overdue";
    StatusType["CANCELLED"] = "cancelled";
    StatusType["ERROR"] = "error";
})(StatusType || (StatusType = {}));
export const getStatusType = (status) => {
    switch (status) {
        case ChargeStatus.PAID:
            return StatusType.PAID;
        case ChargeStatus.PENDING:
            return StatusType.ISSUING;
        case ChargeStatus.PENDING_PAYMENT:
        case ChargeStatus.PENDING_PAYER_CREATE:
        case ChargeStatus.CREATING:
            return StatusType.PENDING;
        case ChargeStatus.CANCELLED:
            return StatusType.CANCELLED;
        case ChargeStatus.OVERDUE:
        case ChargeStatus.EXPIRED:
            return StatusType.OVERDUE;
        case ChargeStatus.ERROR:
            return StatusType.ERROR;
        default:
            return StatusType.PENDING;
    }
};
export const formatDocument = (document) => {
    if (!document)
        return '';
    const numbers = document.replace(/\D/g, '');
    if (numbers.length === 11) {
        return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    else if (numbers.length === 14) {
        return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    return document;
};
export const formatAccountNumber = (account) => {
    if (!account)
        return '';
    const numbers = account.replace(/\D/g, '');
    if (numbers.length > 1) {
        const lastDigit = numbers.slice(-1);
        const mainPart = numbers.slice(0, -1);
        return `${mainPart}-${lastDigit}`;
    }
    return numbers;
};
export const getStatusBadgeClass = (statusType) => {
    switch (statusType) {
        case StatusType.PAID:
            return 'badgeSuccess';
        case StatusType.OVERDUE:
            return 'badgeWarning';
        case StatusType.ERROR:
        case StatusType.CANCELLED:
            return 'badgeError';
        case StatusType.ISSUING:
        case StatusType.PENDING:
        default:
            return 'badgeInfo';
    }
};
